<flx-bottom-panel
  [size]="size()"
  (sizeChange)="size.set($event)"
>
  <ng-container flxExpandPanelHeader>
    @if (uiFlowSession()) {
      <flx-ui-flow-session-details-panel-header
        [name]="uiFlowSession().uiFlowName"
        [uuid]="uiFlowSession().id"
        [state]="uiFlowSession().status"
        subtitle
      />
    }
  </ng-container>

  <ng-container>
    <flx-ui-flow-session-tabs
      [uiFlowSession]="uiFlowSession()"
      [processInstances]="processInstances()"
      class="block h-full"
    />
  </ng-container>
</flx-bottom-panel>
